<ng-container *ngIf="selectorTpl != null; else elseTpl">
  <div (click)="contentClick()">
    <ng-container *ngTemplateOutlet="selectorTpl; context: {item: value}"></ng-container>
  </div>
</ng-container>
<ng-template #elseTpl>
  <ion-item [class.invalid]="isInvalid() && isTouched()">
    <label class="label-text">{{obligatorio ? '* ' : ''}}{{label}}</label>
    <ion-button slot="end" fill="clear" (click)="contentClick()" class="ion-text-right">
      {{value != null && value != '' ? value : '[Seleccione una fecha]'}}
    </ion-button>
  </ion-item>
</ng-template>

<ion-modal class="modal-datefield modalCustom" #modal [keepContentsMounted]="true" (ionModalDidDismiss)="modal.isOpen = false">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="end">
          <ion-button (click)="modal.dismiss()"><ion-icon name="close"></ion-icon></ion-button>
        </ion-buttons>
        <!-- <ion-buttons slot="end">
          <ion-button color="primary" (click)="dateChanged(null)">Limpiar</ion-button>
        </ion-buttons> -->
        <ion-title>Selecciona una fecha</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ion-row class="ion-justify-content-center">
        <ion-datetime #datetime [value]="dateValue" presentation="date" [max]="dentroDeDiezAnos" (ionChange)="dateChanged($event.detail.value, !$event.target.classList.contains('show-month-and-year'))"></ion-datetime>
      </ion-row>
    </ion-content>
    <ion-footer>
      <ion-buttons slot="start">
        <ion-button  color="danger" (click)="dateChanged(null); modal.isOpen = false">Limpiar</ion-button>
      </ion-buttons>
    </ion-footer>
  </ng-template>
</ion-modal>